import { render, staticRenderFns } from "./WorkSelectedHeader.vue?vue&type=template&id=4c7dfa94&scoped=true"
import script from "./WorkSelectedHeader.vue?vue&type=script&lang=js"
export * from "./WorkSelectedHeader.vue?vue&type=script&lang=js"
import style0 from "./WorkSelectedHeader.vue?vue&type=style&index=0&id=4c7dfa94&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7dfa94",
  null
  
)

export default component.exports